/*
 * @description: 路由权限
 * @Author: Jay
 * @Date: 2023-12-19 11:43:18
 * @LastEditors: Jay
 * @LastEditTime: 2026-02-28 16:27:54
 */
import { asyncRoutes, constantRoutes } from '@/router'
import {
  sessionStorage
} from "@/utils/localstorage"

/**
 * 通过meta.role，判断当前用户是否具有权限
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * 通过递归过滤异步路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  //权限
  roles: [],
  //路由列表
  routes: [],
  //动态路由
  addRoutes: [],
  // 权限控制
  // getPermission: [],
}

const mutations = {
  //设置路由
  SET_ROUTES: (state, routes) => {
    //动态路由
    state.addRoutes = routes
    //路由列表 = 动态 + 静态
    state.routes = constantRoutes.concat(routes)
    // console.log('动态路由',  state.addRoutes)
  },
  //设置权限
  SET_ROLES: (state, provider) => {
    state.roles = provider
    // sessionStorage.setItem('rolesPower', provider);
    sessionStorage.set('rolesPower', provider)
    // console.log('设置权限', provider)
  },
  //删除 路由相关缓存
  DELETE_ROUTES() {
    state.routes = []
    state.addRoutes = []
    // 权限
    state.roles = []
    // sessionStorage.removeItem("rolesPower")
    sessionStorage.remove('rolesPower')

  },
  // // 权限控制
  // SET_GET_PERMISSION(state, provider) {
  //   state.getPermission = provider
  // }
}

const actions = {
  // generateRoutes({ commit }, roles) {
  //   return new Promise(resolve => {
  //     let accessedRoutes
  //     if (roles.includes('all')) {
  //       console.log('all 测试')
  //       accessedRoutes = asyncRoutes || []
  //     } else {
  //       console.log('asyncRoutes动态')
  //       accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
  //     }
  //     commit('SET_ROUTES', accessedRoutes)
  //     resolve(accessedRoutes)
  //   })
  // }
  generateRoutes({ commit }, provider) {
    return new Promise(resolve => {
      let accessedRoutes
      let routesConcat = asyncRoutes.concat(provider.routes)
      accessedRoutes = filterAsyncRoutes(routesConcat, provider.roles)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

//开源项目（权限参考）：https://panjiachen.gitee.io/vue-element-admin-site/zh/
